import { combineReducers } from "redux";
import routeplans from "./routeplans/reducer";
import routeinstances from "./routeinstances/reducer";

export default combineReducers({
  routeplans,
  routeinstances
});
